// Preserve the original head/hair; blend a horizontal torso correction below it.
export const TORSO_START_ROW = 470;
const TORSO_BLEND_END_ROW = 500;

export function prepareTorsoTexture(doc, image, frame) {
  const scale = frame.torso_scale ?? 1;
  if (!Number.isFinite(scale) || scale < 0.85 || scale > 1) {
    throw new Error("Invalid torso correction");
  }
  if (scale === 1) return null;
  const canvas = doc.createElement("canvas");
  canvas.width = image.naturalWidth || image.width;
  canvas.height = image.naturalHeight || image.height;
  const context = canvas.getContext("2d");
  if (!context) throw new Error("Torso canvas unavailable");
  // Keep source pixels above the blend for interpolation at its boundary.
  context.drawImage(image, 0, 0);
  for (let row = TORSO_START_ROW; row < canvas.height; row++) {
    const progress = Math.min(1, (row - TORSO_START_ROW) / (TORSO_BLEND_END_ROW - TORSO_START_ROW));
    const blend = progress * progress * (3 - 2 * progress);
    const width = canvas.width * (1 + (scale - 1) * blend);
    context.clearRect(0, row, canvas.width, 1);
    context.drawImage(image, 0, row, canvas.width, 1,
      (canvas.width - width) / 2, row, width, 1);
  }
  return canvas;
}

export function drawBustTexture(context, image, torso, transform, width, height) {
  const drawWidth = width * transform.scale, drawHeight = height * transform.scale;
  context.clearRect(0, 0, width, height);
  context.drawImage(image, transform.x, transform.y, drawWidth, drawHeight);
  if (!torso) return;
  const top = transform.y + TORSO_START_ROW * transform.scale;
  context.save();
  context.beginPath();
  context.rect(0, top, width, height - top);
  context.clip();
  context.clearRect(0, 0, width, height);
  context.drawImage(torso, transform.x, transform.y, drawWidth, drawHeight);
  context.restore();
}
